import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      stroke: "white",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("rect", {
      x: "16.2422",
      y: "9.17188",
      width: "10",
      height: "2",
      transform: "rotate(135 16.2422 9.17188)",
      fill: "white"
    }, null, -1),
    _createElementVNode("rect", {
      x: "14.8281",
      y: "16.2432",
      width: "10",
      height: "2",
      transform: "rotate(-135 14.8281 16.2432)",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }